import { useCallback } from "react"
import { Button, ButtonProps, CoinsHand, Settings03 } from "@mezo-org/mezo-clay"
import { Link } from "@tanstack/react-router"

import {
  selectUserHasLoan,
  setOpenModal,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import { routes } from "#/shared/constants"
import { usePosthogButtonClickedEvent } from "#/shared/hooks"
import { PosthogAnalyticsId } from "#/shared/types"

export default function OverviewAssetsLoanButton() {
  const hasLoan = useDappSelector(selectUserHasLoan)
  const dispatch = useDappDispatch()

  const { emitButtonClickedEvent } = usePosthogButtonClickedEvent()

  const borrowModalHandler = useCallback(() => {
    if (hasLoan) return

    dispatch(setOpenModal("borrow-first"))
  }, [hasLoan, dispatch])

  const borrowButtonHandler = useCallback(() => {
    if (hasLoan) return

    emitButtonClickedEvent(PosthogAnalyticsId.MUSD_BORROW)
  }, [hasLoan, emitButtonClickedEvent])

  const buttonProps: ButtonProps = hasLoan
    ? {
        "data-attr": "update_loan_cta",
        $as: Link,
        onClick: borrowButtonHandler,
        href: routes.BORROW,
      }
    : {
        "data-attr": "main-start_borrow_cta",
        onClick: borrowModalHandler,
      }

  return (
    <Button
      size="small"
      {...buttonProps}
      overrides={{
        BaseButton: { style: () => ({ width: "100px" }) },
      }}
      startEnhancer={
        hasLoan ? (
          <Settings03 size={16} color="white" />
        ) : (
          <CoinsHand size={16} color="white" />
        )
      }
    >
      {hasLoan ? "Manage" : "Borrow"}
    </Button>
  )
}
